import { Component, OnInit, Inject, Input, Optional } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/security/auth.service';

@Component({
  selector: 'app-error-msg',
  templateUrl: './error-msg.component.html',
  styleUrls: ['./error-msg.component.scss']
})
export class ErrorMsgComponent implements OnInit {
  private defaultErrorMessage = 'An error occurred. Please check the information and try again.';
  private forbiddenMessage = 'Sorry, you are not authorized to access this resource.  Please contact a BMI Administrator to request access.'
  private unauthorizedMessage = 'Unauthorized, please log in.';
  private notFoundMessage = 'The requested resource was not found.';
  private escalateErrorMessage = 'An error occurred. If the error continues, please contact a BMI Administrator.';

  message: string = this.defaultErrorMessage;
  messages: string[] = [];

  @Input() errorResponse: HttpErrorResponse;

  constructor(
    @Optional() @Inject(MAT_SNACK_BAR_DATA) data: HttpErrorResponse,
    private router: Router,
    private authService: AuthService,
  ) {
    if (data) {
      this.errorResponse = data;
    }
  }

  ngOnInit() {
    if (!this.errorResponse) { return; }

    switch (this.errorResponse.status) {
      case 422:
      case 409:
      case 400:
        this.extractMessages(this.errorResponse.error);
        break;
      case 404:
        this.message = this.notFoundMessage;
        break;
      case 403:
        this.message = this.forbiddenMessage;
        break;
      case 401:
        this.message = this.unauthorizedMessage;
        this.authService.setUser(null);
        this.router.navigate(['/account']);
        break;
      default:
        this.message = this.defaultErrorMessage;
        break;
    }
  }

  private extractMessages(errorObject: any): void {
    console.log(errorObject);
    if (Array.isArray(errorObject)) {
      this.messages = errorObject.map(x => x.description || x.toString());
      this.message = null;
    } else {
      let errorObjectToString = errorObject?.toString();
      let isErrorObjectToStringAnObject: boolean = errorObjectToString == "[object Object]";
      this.message = errorObject?.message
        || (isErrorObjectToStringAnObject
            ? this.escalateErrorMessage
            : errorObjectToString);
      if (errorObject?.modelState?.validation)
        this.messages = errorObject.modelState.validation.map((x: any) => x.toString());
      else if (errorObject?.errors)
        this.message = this.escalateErrorMessage;
      else
        this.messages = [];
    }
  }

}
